<template>
  <div class="action-buttons-wrapper">
    <div
      v-if="editButton"
      class="btn-top"
    >
      <el-button
        :type="editButton.type"
        :icon="editButton.icon"
        @click="$emit('edit', item)"
      >
        Hồ Sơ
      </el-button>
    </div>
    <div
      v-if="otherActions.length > 0"
      class="btn-bottom"
    >
      <el-dropdown
        trigger="click"
        @command="handleCommand"
      >
        <el-button
          size="medium"
          type="default"
          plain
        >
          Thao tác <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="action in otherActions"
            :key="action.key"
            :command="action.key"
            :class="action.type === 'danger' ? 'text-danger' : ''"
          >
            <i
              v-if="action.icon"
              :class="action.icon"
              class="mr-s"
            />
            {{ action.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import constants from "@/config/constants";
export default {
  name: "ActionButtons",
  props: {
    item: Object,
    buttons: Array,
  },
  computed: {
    data() {
      return constants.ALL_ACTIONS.filter((a) =>
        (this.buttons || []).includes(a.key)
      );
    },
    editButton() {
      return this.data.find((a) => a.key === "edit");
    },
    otherActions() {
      return this.data.filter((a) => a.key !== "edit");
    },
  },
  methods: {
    handleCommand(command) {
      this.$emit(command, this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.action-buttons-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto;

  .btn-top {
    width: 100%;
    margin-bottom: 6px;
    display: flex;
    justify-content: center;

    .el-button {
      width: 100%;
    }
  }

  .btn-bottom {
    width: 100%;
    display: flex;
    justify-content: center;

    .el-dropdown {
      width: 100%;
      display: flex;
      justify-content: center;

      .el-button {
        width: 100%;
      }
    }
  }
}
</style>

